import * as THREE from 'three';

export function createRenderer(canvas: HTMLCanvasElement): THREE.WebGLRenderer {
  let reason = '';
  const onError = (event: Event) => { reason = (event as WebGLContextEvent).statusMessage; };
  canvas.addEventListener('webglcontextcreationerror', onError);
  let context: WebGL2RenderingContext | null = null;
  try {
    // Let the browser select its stable GPU rather than requesting a GPU switch.
    context = canvas.getContext('webgl2', { alpha: false, antialias: true, powerPreference: 'default' });
    if (!context) context = canvas.getContext('webgl2', { alpha: false, antialias: false, powerPreference: 'default' });
  } finally {
    canvas.removeEventListener('webglcontextcreationerror', onError);
  }
  if (!context) throw new Error(`No se pudo crear WebGL 2. ${reason || 'El navegador no pudo habilitar los gráficos 3D.'}`);
  const renderer = new THREE.WebGLRenderer({
    canvas,
    context,
    alpha: false,
  });
  renderer.outputColorSpace = THREE.SRGBColorSpace;
  renderer.toneMapping = THREE.ACESFilmicToneMapping;
  renderer.toneMappingExposure = 1.05;
  renderer.shadowMap.enabled = true;
  renderer.shadowMap.type = THREE.PCFShadowMap;
  return renderer;
}

export function resizeRenderer(
  renderer: THREE.WebGLRenderer,
  camera: THREE.PerspectiveCamera,
  maxDpr = 2,
): boolean {
  const canvas = renderer.domElement;
  const width = Math.max(1, Math.floor(canvas.clientWidth));
  const height = Math.max(1, Math.floor(canvas.clientHeight));
  const dpr = Math.min(window.devicePixelRatio || 1, maxDpr);
  const bufferWidth = Math.floor(width * dpr);
  const bufferHeight = Math.floor(height * dpr);
  const needsResize = canvas.width !== bufferWidth || canvas.height !== bufferHeight;

  if (needsResize) {
    renderer.setPixelRatio(dpr);
    renderer.setSize(width, height, false);
    camera.aspect = width / height;
    camera.updateProjectionMatrix();
  }

  return needsResize;
}
